import { Component, OnInit, input, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { ShowCookieSettings } from '@teamfoster/sdk/cookie-ngrx';
import { DictionarySignalsModule, FromDictionaryPipe } from '@teamfoster/sdk/dictionary-signals';
import { MenuItem } from '@teamfoster/sdk/menu-ngrx';
import { SocialChannel } from 'src/app/social-media/models';
import { SocialChannelButtonsComponent } from 'src/app/social-media/components/social-channel-buttons/social-channel-buttons.component';
import { TrackLinkClickDirective } from 'src/app/shared/directives/track-link-click.directive';
import { LinkComponent } from '@teamfoster/sdk/button';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [FromDictionaryPipe, DictionarySignalsModule, SocialChannelButtonsComponent, TrackLinkClickDirective, LinkComponent],
})
export class FooterComponent implements OnInit {
  private store = inject(Store);

  private dict = new FromDictionaryPipe();

  domain = input<string>('');
  menu = input<MenuItem[]>([]);
  metaMenu = input<MenuItem[]>([]);
  socials = input<SocialChannel[]>([]);
  schema = input<any>({
    '@context': 'http://schema.org',
    '@type': this.dict.transform('meta:footer-json-ld-meta-type'),
    'name': this.dict.transform('meta:titel'),
    'url': this.domain,
    'logo': `${this.domain}/assets/gfx/logo.svg`,
    'contactPoint': {
      '@type': 'ContactPoint',
      'email': this.dict.transform('contact-email'),
      'contactType': 'customer service',
    },
    'sameAs': [],
  });

  year = new Date().getFullYear();

  ngOnInit(): void {
    this.socials().forEach(s => {
      const socialLink = s; // to do config with social buttons
      this.schema().sameAs.push(socialLink);
    });
  }

  openCookie() {
    this.store.dispatch(ShowCookieSettings());
  }
}
